module.exports = __webpack_public_path__ + "static/MB-9f159e92774317913fb632800cf9ad93.jpg";